import { Icon, Spinner } from "@atoms";
import { BrightnessType, SizeType } from "@theme/types";
import { widthMixin } from "@theme/mixins";
import { PRIMARY_BUTTON_SIZE } from "./constants";

export type PrimaryButtonTemplateProps = {
  onClick?: () => void;
  label: string;
  stretch?: boolean;
  autosize?:boolean;
  size?: SizeType;
  withIcon?: any;
  color: string;
  textColor?: string;
  textSize?: string;
  textWeight?: string;
  hoverColor?: string;
  brightness?: BrightnessType;
  type?: "button" | "submit";
  loading?: boolean;
  height?: number;
  width?: number;
  disabled?: boolean;
  className?: string;
  paddingXClassName?: string;
};

export const PrimaryButtonTemplate = ({
  onClick,
  label,
  stretch,
  autosize,
  size,
  color, // Could make the default color be the brand blue
  textColor = "white",
  textSize = "md",
  textWeight = "normal",
  hoverColor = "primary-dark",
  withIcon,
  type = "button",
  loading,
  disabled = false,
  className,
  paddingXClassName,
}: PrimaryButtonTemplateProps): JSX.Element => {
  const horizontalPaddingClass = paddingXClassName ?? "px-3";

  return (
    <button
      type={type}
      className={`${widthMixin({
        table: PRIMARY_BUTTON_SIZE,
        size,
        stretch,
        autosize,
        centered: true,
      })} py-2 ${horizontalPaddingClass} rounded-full min-h-full duration-150
      hover:bg-${hoverColor} hover:opacity-80 bg-${color} text-${textColor} disabled disabled:bg-gray-100 disabled:cursor-not-allowed disabled:pointer-events-none disabled:opacity-25 ${className ?? ""}`}
      {...(onClick && { onClick })}
      disabled={disabled}
    >
      <div style={{height: 25}} className="flex items-center">
        {withIcon && !loading ? (
          <div style={{ bottom: 0.5 }} className="mr-3 relative">
            {/* TODO: Only icons are for rocket on airdrop and google. Google doesn't use the color prop, if that ever changes please update accordingly */}
            <Icon variant={withIcon} height={16} width={16} color={"white"} />
          </div>
        ) : null}
        {loading ? <Spinner /> : <span className={`text-${textSize} font-${textWeight}`}>{label}</span>}
      </div>
    </button>
  );
};
